/**
 * PackshotPickerEmptyState - Kein Analyseergebnis für ein Produkt
 */

import { Camera } from 'lucide-react'
import { Button } from '@/components/v2/ui'

interface PackshotPickerEmptyStateProps {
  onStartAnalysis?: () => void
}

export function PackshotPickerEmptyState({ onStartAnalysis }: PackshotPickerEmptyStateProps) {
  return (
    <div className="packshot-picker-empty flex flex-col items-center gap-3 py-5 px-4 rounded-xl border border-dashed border-neutral-200 dark:border-neutral-700 bg-neutral-50 dark:bg-neutral-800/30 text-center">
      <div className="w-10 h-10 rounded-full bg-neutral-100 dark:bg-neutral-700 flex items-center justify-center">
        <Camera className="h-5 w-5 text-neutral-400" aria-hidden="true" />
      </div>
      <div>
        <p className="text-sm text-neutral-600 dark:text-neutral-400 font-medium">
          Keine KI-Analyse vorhanden
        </p>
        <p className="text-xs text-neutral-400 mt-0.5">
          Starte eine Analyse um Bilder automatisch zu bewerten
        </p>
      </div>
      {onStartAnalysis && (
        <Button variant="outline" size="sm" onClick={onStartAnalysis}>
          Analyse starten
        </Button>
      )}
    </div>
  )
}
